import React from 'react';
import Base64 from 'Base64';

import 'jqwidgets-scripts/jqwidgets/styles/jqx.base.css';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.dark.css';
import JqxComboBox, { IComboBoxProps, jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxcombobox';


class VtxComboBox extends React.Component  {
    myComboBox = React.createRef();
	constructor(props){
		super(props);
        this.comboBoxOnChange = this.comboBoxOnChange.bind(this);
        this.btnOnClick = this.btnOnClick.bind(this);
		this.state = {
            data : [],
            defaultValue : this.props.default, 
            table : this.props.table, 
            valueField : this.props.valueField, 
            displayField : this.props.displayField, 
            filterField : this.props.filterField, 
            filterValue  : this.props.filterValue,
            multiSelect     :   this.props.multiSelect,
            source: new Array('Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo, Democratic Republic', 'Congo, Republic of the', 'Costa Rica', 'Cote d`Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Greenland', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Mongolia', 'Morocco', 'Monaco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Samoa', 'San Marino', ' Sao Tome', 'Saudi Arabia', 'Senegal', 'Serbia and Montenegro', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe')
        };

		let requestOptions = {
			method: 'GET',
			headers: {
				'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')
			}
		};
        
		fetch('http://renobuilding.ca/wp-json/reno/v1/query?table=' + this.state.table + '&filterfield=' + this.state.filterField + '&filtervalue=' + this.state.filterValue , requestOptions)
		.then(response => {
		  return Promise.all([response.json(),response])
		})
		.then(([responseData,response]) => {
            console.log(responseData)
            var source = {
                datafields: [
                    { name: this.props.valueField },
                    { name: this.props.displayField }
                ],
                datatype: 'json',
                localdata: responseData
            };
            this.setState({data :  new jqx.dataAdapter(source)});
			//console.log(responseData);
		})
		.catch(error => {
			console.error('Error:', error);
		})		
    }
    onChnageHandler = (event) =>{
        event.persist();
        //console.log(event.target.value);
        this.props.onChange(event);
    };

    comboBoxOnChange() {
        const items = this.myComboBox.current.getSelectedItems();
        let selectedItems = ';';
        let id = this.props.id;
        if(this.state.multiSelect)
            items.map(item => selectedItems += `${item.value};`);
        else
            selectedItems = this.myComboBox.current.getSelectedItem().value;
        this.props.comboBoxOnChange({id,selectedItems});
    }

    btnOnClick() {
        this.myComboBox.current.setOptions({ showArrow: false });
    }

    render(){
        const data = this.state.data;
        return(
            <>
            <div>
                <JqxComboBox 
                    ref={this.myComboBox} 
                    onChange={this.comboBoxOnChange}  
                    width="100%"
                    height="35px"                  
                    source={this.state.data}
                    multiSelect={this.state.multiSelect} 
                    displayMember={this.props.displayField} 
                    valueMember={this.props.valueField}
                    searchMode="startswith"
                    autoComplete={true}
                    defaultValue={this.state.defaultValue}
                    />
            </div>
            </>
        );
    }
}


export default VtxComboBox;